import React, { useLayoutEffect } from "react";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
  Link,
} from "react-router-dom";

import Login from "./pages/Login";
// import Profile from './components/Profile';
import Profile from "./pages/Profile";
// import MyShowcase from "./pages/Profile/MyShowcase";
import UserProfile from "./pages/Profile/UserProfile";
// import UserProfile from "./pages/UserProfile";
import PublicProfile from "./pages/Profile/PublicProfile";

import LoginValidation from "./pages/Login/Validation";
import Learning from "./pages/Learning";
import TeachingPages from "./pages/Teaching";

import PostView from "./pages/PostView";
import AnnounceView from "./pages/AnnounceView";
import EditState from "./pages/Profile/EditState";

import JournalPages from "./pages/Journal";
import CommunityPages from "./pages/Community";

import TOU from "./pages/Static/TOU";
import PrivacyPolicy from "./pages/Static/PrivacyPolicy";

import GuestTOU from "./pages/Static/GuestTOU";
import GuestPrivacyPolicy from "./pages/Static/GuestPrivacyPolicy";

import { connect, Provider } from "react-redux";
import store from "./redux/store";

import * as auth from "./redux/actions/auth";
import * as termsconditionsReducer from "./redux/actions/termsconditionsActions";
import AccountSettings from "./pages/Profile/AccountSettings";
import PresentView from "./pages/PostView/PresentView";
import PublicPostView from "./pages/PostView/PublicPostView";
import GroupFeed from "./pages/Community/GroupFeed";

import GATracker from "./services/ga.js";
import GuestPublicLogin from "./pages/Login/GuestPublicLogin";
import GuestPublicProfile from "./pages/Profile/GuestPublicProfile";
import GuestPublicPostView from "./pages/PostView/GuestPublicPostView";

import axios from "axios";
import {
  apiUrl,
  serverUrl,
  checkENV,
  appENV,
} from "./components/Helpers/Config";
import { Loading, tokenAuthorize } from "./components/Helpers/Common";
// import GoogleMap from "./pages/Map/GoogleMap";
import GoogleApiWrapper from "./pages/Map/GoogleMap";

import AnalyticsPages from "./pages/Analytics";
import Loader from "./components/Button/Loader.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

let TRACKING_ID = "UA-XXXXXXXXX-X";
let IS_TRACKING = false;

if (process.env.REACT_APP_GA_TRACKING && process.env.REACT_APP_GA_CODE) {
  if (
    !isNaN(process.env.REACT_APP_GA_TRACKING) &&
    parseInt(process.env.REACT_APP_GA_TRACKING) === 1
  ) {
    TRACKING_ID = process.env.REACT_APP_GA_CODE;
    IS_TRACKING = true;
  }
}

const NoMatch = ({ location }) => (
  <div className="text-center">
    <h1 className="mt-16 md:mt-32 p-8 text-6xl">Page Not Found</h1>
    <p className="text-lg mb-12">
      Sorry, the page you were looking for could not be found.
    </p>
    <Link to="/" className="mt-24" title="Home">
      Go to homepage
    </Link>
  </div>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    document.body.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

class RootContainerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuList: [],
      userId: 0,
      loader: true,
    };
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAY2jkSWLuXmTltSC6q1CfTCMdGLvphKSY&libraries=places`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    this.props.loadUser();
    if (
      this.props.auth.user != null &&
      this.state.userId != this.props.auth.user?.user_id
    ) {
      this.setState({
        userId: this.props.auth.user?.user_id,
      });
      // this.getmenuList();
      this.setState({ loader: true });
      Promise.all([
        this.props.getMenuItems(this?.props?.auth?.user?.guid),
        this.props.getUserTheme(),
        this.props.getCommunitySubMenus(this?.props?.auth?.user?.guid),
        this.props.getTermsandConditions(),
      ])
        .then(() => {
          this.setState({ loader: false });
        })
        .catch((error) => {
          this.setState({ loader: false });
        });
      // this.props.loadVBE();
    }
    this.idleLogout();
  }

  idleLogout = () => {
    const IDLE_TIME = 1200000;

    function logOut() {
      localStorage.setItem("idleTime", "true");
    }

    function resetTimer() {
      const d = new Date();
      d.setSeconds(0);
      d.setMilliseconds(0);
      const currentTime = d.getTime();
      localStorage.setItem("lastActivityTime", currentTime);
    }

    function checkIdleTime() {
      const d = new Date();
      d.setSeconds(0);
      d.setMilliseconds(0);
      const currentTime = d.getTime();
      const lastActivityTime = parseInt(
        localStorage.getItem("lastActivityTime")
      );
      if (
        lastActivityTime != undefined &&
        lastActivityTime != null &&
        currentTime - lastActivityTime >= IDLE_TIME
      ) {
        logOut();
      } else {
        clearTimeout(t);
        t = setTimeout(checkIdleTime, IDLE_TIME);
      }
    }

    resetTimer();
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.ontouchstart = resetTimer;
    window.ontouchmove = resetTimer;
    window.onclick = resetTimer;
    window.onkeydown = resetTimer;
    window.addEventListener("scroll", resetTimer, true);

    let t = setTimeout(checkIdleTime, IDLE_TIME);
  };

  componentDidUpdate() {
    if (
      this.props.auth.user != null &&
      this.state.userId != this.props.auth.user?.user_id
    ) {
      this.setState({
        userId: this.props.auth.user?.user_id,
      });
      this.setState({ loader: true });
      Promise.all([
        this.props.getMenuItems(this?.props?.auth?.user?.guid),
        this.props.getUserTheme(),
        this.props.getCommunitySubMenus(this?.props?.auth?.user?.guid),
        this.props.getTermsandConditions(),
      ])
        .then(() => {
          this.setState({ loader: false });
        })
        .catch((error) => {
          this.setState({ loader: false });
        });
    }
  }

  getmenuList = () => {
    axios
      .get(serverUrl.GetMenus2 + "/" + this.props.auth.user?.guid)
      .then((resp) => {
        if (resp.status === 200) {
          this.setState({
            menuList: resp?.data,
          });
        } else if (resp.status >= 400 && resp.status < 500) {
        }
        this.setState({ loader: false });
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
        this.setState({ loader: false });
      });
  };

  PrivateRoute = ({ component: ChildComponent, render, ...rest }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (this.props.auth.isLoading) {
            return <Loader />;
          } else if (!this.props.auth.isAuthenticated) {
            if (window.location.pathname?.includes("/profile/")) {
              sessionStorage.setItem("profilePath", "true");
              sessionStorage.setItem(
                "profileCurrentPath",
                window.location.pathname
              );
            }
            return (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { next: props.location.pathname },
                }}
              />
            );
          } else {
            return this.state.loader ? (
              <Loader />
            ) : render ? (
              render(props)
            ) : (
              <ChildComponent {...props} />
            );
          }
        }}
      />
    );
  };

  GuestPrivateRoute = ({ component: ChildComponent, ...rest }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          let userCode = "";
          if (
            rest.computedMatch.params !== null &&
            rest.computedMatch.params.userId !== null
          ) {
            userCode = rest.computedMatch.params.userId;
            // publicToken = localStorage.getItem("dp2_token_access_" + userCode);
          }

          if (
            (this.props.auth.isPublicLoading && userCode.length > 0) ||
            (this.props.auth.isPublicAuth &&
              this.props.auth.publicToken === null)
          ) {
            if (
              !this.props.auth.isPublicLoading &&
              this.props.auth.publicToken === null
            ) {
              this.props.loadUserPublic(userCode);
            }
            return <Loader />;
          } else if (this.props.auth.publicToken === null) {
            return (
              <Redirect
                to={{
                  pathname:
                    userCode.length > 0
                      ? "/login/public/" + userCode + rest?.location?.search
                      : "/login/",
                  state: { next: rest.location.pathname },
                }}
              />
            );
          } else {
            return <ChildComponent {...props} />;
          }
        }}
      />
    );
  };

  render() {
    let { PrivateRoute } = this;
    let { GuestPrivateRoute } = this;
    const isLoading = this.props.auth.isLoading;
    // let { menuList }=this;
    // let value = this.state.menuList?.map((menu) => {
    //   return menu.path;
    // })
    let value = this?.props?.auth?.menu_items?.map((menu) => {
      return menu.path;
    });

    if (isLoading) {
      return <Loader />;
    }
    return (
      <>
        {this.props.isThemeLoader && <Loader />}
        <Router
          basename={appENV === checkENV ? "" : "digitalportfolio2"}
        // basename=""
        >
          {/* Toast container placed globally */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnHover
            draggable
          />

          <GATracker
            trackingId={TRACKING_ID}
            isTracking={IS_TRACKING}
            isDev={false}
          />
          <ScrollToTop />
          <Switch>
            {appENV === checkENV ? (
              <Route
                exact
                path="/login/validate/:token"
                component={LoginValidation}
              />
            ) : (
              <Route exact path="/login/validate" component={LoginValidation} />
            )}
            <Route
              path="/login/public/:sharedCode"
              component={GuestPublicLogin}
            />
            <Route path="/login" component={Login} />

            {/* New Route starts here */}

            {/* <PrivateRoute path="/userprofiledata/:userId" component={UserProfile} /> */}
            <PrivateRoute
              path="/profile/:userId/post/:postId"
              component={PublicPostView}
            />
            <PrivateRoute path="/profile/:userId" component={PublicProfile} />
            <GuestPrivateRoute
              path="/public/:userId/post/:postId"
              component={GuestPublicPostView}
            />
            <GuestPrivateRoute
              path="/public/:userId"
              component={GuestPublicProfile}
            />

            <PrivateRoute
              exact
              path="/account-settings"
              component={AccountSettings}
            />

            <PrivateRoute path="/edit-layout" component={EditState} />

            {/* {this.state?.menuList[0]?.path ?
            <Route
              exact
              path="/"
              render={() => {
                const firstPath = this.state?.menuList?.[0]?.path;
                if (firstPath && firstPath !== "/") {
                  return <Redirect to={firstPath} />;
                } else {
                  return <UserProfile />;
                }
              }}
            />
            :
            <PrivateRoute path="/" component={UserProfile} />
          } */}

            {this?.props?.auth?.menu_items &&
              this?.props?.auth?.menu_items[0]?.path ? (
              <PrivateRoute
                exact
                path="/"
                render={() => {
                  const firstPath = this?.props?.auth?.menu_items[0]?.path;
                  if (firstPath && firstPath !== "/") {
                    return <Redirect to={firstPath} />;
                  } else {
                    return <UserProfile />;
                  }
                }}
              />
            ) : (
              <PrivateRoute path="/" component={UserProfile} />
            )}
            {/* <PrivateRoute exact path="/myshowcase" component={MyShowcase} /> */}
            {/* <PrivateRoute exact path="/" component={Profile} /> */}
            {this?.props?.auth?.menu_items?.some(
              (s) => s.path === "/journal"
            ) && <PrivateRoute path="/journal" component={JournalPages} />}

            {this?.props?.auth?.menu_items?.some(
              (s) => s.path === "/tasks"
            ) && <PrivateRoute path="/tasks" component={Learning} />}

            <Route path="/community/groups/:groupId" component={GroupFeed} />

            {this?.props?.auth?.menu_items?.some(
              (s) => s.path === "/community"
            ) && <PrivateRoute path="/community" component={CommunityPages} />}

            {this?.props?.auth?.menu_items?.some(
              (s) => s.path === "/teaching"
            ) && <PrivateRoute path="/teaching" component={TeachingPages} />}

            {this?.props?.auth?.menu_items?.some(
              (s) => s.path === "/analytics"
            ) && <PrivateRoute path="/analytics" component={AnalyticsPages} />}

            <PrivateRoute path="/present/:showcaseId" component={PresentView} />
            <PrivateRoute path="/post/:postId" component={PostView} />
            <PrivateRoute path="/announcement/:id" component={AnnounceView} />
            <PrivateRoute path="/map" component={GoogleApiWrapper} />

            <PrivateRoute path="/privacy-policy" component={PrivacyPolicy} />
            <PrivateRoute path="/terms-of-use" component={TOU} />

            <Route
              path="/general/privacy-policy"
              component={GuestPrivacyPolicy}
            />
            <Route path="/general/terms-of-use" component={GuestTOU} />

            {(
              value?.length !== 0
                ? value?.includes(window.location.pathname)
                : true
            ) ? (
              !window.location.pathname.includes("/login") ? (
                <Route component={Loading} />
              ) : (
                <Route component={NoMatch} />
              )
            ) : (
              <Route component={NoMatch} />
            )}
          </Switch>
        </Router>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    termsconditionsReducer: state.termsconditionsReducer,
    isThemeLoader: state.auth.isThemeLoader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadUser: () => {
      return dispatch(auth.loadUser());
    },
    loadUserPublic: (userCode) => {
      return dispatch(auth.loadUserPublic(userCode));
    },
    getUserTheme: () => {
      return dispatch(auth.getUserTheme());
    },
    getCommunitySubMenus: (guid) => {
      return dispatch(auth.getCommunitySubMenus(guid));
    },
    getMenuItems: (guid) => {
      return dispatch(auth.getMenuItems(guid));
    },
    getTermsandConditions: () => {
      return dispatch(termsconditionsReducer.getTermsandConditions());
    },
  };
};

let RootContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RootContainerComponent);

const App = () => {
  return (
    <>
      <Provider store={store}>
        <RootContainer />
      </Provider>
    </>
  );
};

export default App;
